import { Link } from "react-router-dom";
import scrollToTop from "../components/scrolltotop";
import { usps } from "../data/uspdata";
import { Icon } from "@iconify/react";
const AboutPage = () => {
  return (
    <>
      <div className="about-page-container">
        <div className="hero">
          <div className="text">
            <h1>Building confident learners</h1>
            <p>
              <strong>Welcome to Cito’s Learners</strong>
              <br /> At Cito’s Learners we specialise in 11+ tutoring, but what
              offer goes far beyond exam preparation. We are passionate about
              building strong foundations that support confident, capable
              learners for life.
              <br />
              <br />
              Our focus is on equipping your child with skills that will last
              well beyond the classroom. Whether preparing for the 11+ or simply
              looking to strengthen their understanding and confidence, at
              Cito’s Learners we support every child on their individual
              journey.
              <br />
              <br />
              We’re proud of the journey we’ve taken and the community we’ve
              built. Scroll down to learn more about our story and why Cito’s
              Learners is the right place for your child.
            </p>
            {/*<Link to="/courses" className="btn lbtn">
              Explore our courses
            </Link>*/}
          </div>
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/about/abouthero.webp"
            alt="abouthero"
          />
          <h1 className="ipadh1">Building confident learners</h1>
        </div>

        <div className="sect2">
          <div className="bigcircle"></div>
          <div className="bigcircle"></div>
          <div className="smallcircle"></div>
          <div className="smallcircle"></div>
          <div className="textcircle">
            <div className="content">
              <h3>Who we are</h3>
              <p>
                We are <span className="shortener"> Cito’s Learners, </span>a
                tutoring company{" "}
                <span className="shortener">founded by two friends,</span>{" "}
                united by a shared belief: learning should inspire confidence,
                independence, tenacity and optimism. W
                <span className="shortener">
                  ith a shared passion for education and years of hands-on
                  experience, w
                </span>
                e have combined our expertise
                <span className="shortener">, insight and creativity </span>to
                help students unlock their full potential.
              </p>
            </div>
          </div>
          <div className="textcircle">
            <div className="content">
              <h3>Our mission</h3>
              <p>
                <span className="shortener">Our mission is simple, w</span>
                <span className="fix">W</span>e want to make learning enjoyable,
                engaging, and <span className="shortener">genuinely </span>
                impactful for every child{" "}
                <span className="shortener">we support</span>. We design
                learning experiences that go beyond memorising facts,{" "}
                <span className="shortener">instead we </span>
                encourage critical thinking,{" "}
                <span className="shortener">spark creativity, </span>and build a
                strong academic foundation{" "}
                <span className="shortener">
                  rooted in resilience and a positive attitude towards learning
                </span>
                .
              </p>
            </div>
          </div>
        </div>

        <div className="sect3">
          <div className="text">
            <h3>Learning that lasts a lifetime</h3>
            <p>
              We’re not only preparing your child to pass their 11+ exams, we’re
              shaping
              <br /> the way that they learn, think, and overcome challenges
              today and forever.  
            </p>
            <Link to="/courses" onClick={scrollToTop} className="btn">
              Find the perfect course for you
            </Link>
          </div>
          <div className="img-holder">
            <img
              src="https://d1sq738v7irhr2.cloudfront.net/about/evolution.webp"
              alt="aboutimg"
            />
          </div>
          <h3 className="ipadh3">Learning that lasts a lifetime</h3>
        </div>
        <div className="sect4">
          <h3>Our story</h3>
          <p>
            Cito’s Learners grew from countless conversations, shared
            observations, and one truth: too many students feel overwhelmed,
            discouraged, or disconnected from their learning experiences, and we
            wanted to change that.
            <br />
            <br />
            Tutoring wasn’t something we set out to do; it was something we
            found ourselves doing to earn extra money during our school years.
            But what started casually soon revealed a deeper mutual passion for
            teaching, mentoring, and watching students grow academically and
            personally.
            <br />
            <br />
            As we continued tutoring, we identified a major gap in the market: a
            lack of well-structured, thoughtfully designed curricula that
            holistically prepares children for the 11+ exams. So, we set out to
            create the solution — and Cito’s Learners was born.
            <br />
            <br />
            We knew firsthand the academic challenges that come with sitting the
            11+, but also the emotional toil that it can take on students and
            parents. What began as a small idea has become a trusted partnership
            grounded in empathy and a genuine commitment to your child’s
            success.
            <br />
            <br />
            Today, Cito’s Learners stands proudly as a provider of high-quality
            and structured learning experiences tailored specifically for the
            11+ journey.
          </p>
        </div>
        <div className="sect5">
          <h3>Why choose us</h3>
          <p>
            Choosing Cito’s Learners means choosing a team that cares about your
            child’s growth far beyond the 11+ curriculum. Here’s what makes us
            different:
          </p>

          {usps.map((usps, index) => (
            <div className="usp" key={index}>
              <div className="tickntitle">
                <Icon className="icon" icon="lets-icons:check-fill" />{" "}
                <h5>{usps.title}</h5>
              </div>
              <p>{usps.text}</p>
            </div>
          ))}
          <p>
            We’re more than a tutoring company – we’re a community. Joining
            Cito’s Learners means joining a supportive family that places your
            child’s wellbeing, growth, and success at the heart of everything we
            do.
          </p>
        </div>
        <div className="sect6">
          <h5>Let’s start the learning journey</h5>
          <p>
            Whether your child needs support, a challenge or simply
            <br /> a fun and engaging way to learn, we’re here to help them{" "}
            <br />
            grow.
          </p>
          <div className="btns-container">
            <Link className="btn alt" to="/assessment" onClick={scrollToTop}>
              Book a free assessment
            </Link>
            <Link className="btn" to="/contact" onClick={scrollToTop}>
              Get in touch
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
